export default __webpack_public_path__ + "static/media/smile.0c9b1c61.svg";